import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { getAssetPath } from './utils/paths';
import Header from './components/Header';
import Hero from './components/Hero';
// import Approach from './components/About'; // Hidden for now
import AboutPersonal from './components/AboutPersonal';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Gallery from './components/Gallery';
import BusinessCard from './components/BusinessCard';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

// ScrollToTop component to handle scrolling to top on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top with smooth behavior
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time for smooth animations
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Get the background image path
    const bgImagePath = getAssetPath('background.jpg');
    // Add cache-busting query parameter to force browser to reload new image
    const timestamp = new Date().getTime();
    const imageUrl = `${bgImagePath}?v=${timestamp}`;
    console.log('Setting background image path:', imageUrl);
    console.log('Base path:', bgImagePath);
    document.documentElement.style.setProperty('--bg-image', `url("${imageUrl}")`);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <h2 className="loading-text">Pro Nurse Legal</h2>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Hero />} />
            {/* Approach route hidden for now */}
            {/* <Route path="/approach" element={<Approach />} /> */}
            <Route path="/about" element={<AboutPersonal />} />
            <Route path="/resume" element={<Experience />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/business-card" element={<BusinessCard />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

